module.exports = __webpack_public_path__ + "static/media/joDreiling.bab9837f.jpg";